import { all, call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  AuthActions,
  LoginActions,
  LoginRequestAction,
} from 'store/ducks/auth';
import {
  PaginationParamsCacheActions,
  WarehouseScheduleParamsCacheActions,
} from 'store/ducks/cache';
import { YMS_PORTARIA_MEMBER_TYPE } from 'contracts/Auth';

const INVALID_CREDENTIALS_MESSAGE = 'E-mail e/ou senha de acesso incorretos';

export function* loginRequest(action: any) {
  const { postData, onSuccess, onFailure }: LoginRequestAction = action;
  try {
    const { data } = yield call(api.post, 'auth/login', postData);
    if (data?.profile?.type === YMS_PORTARIA_MEMBER_TYPE) {
      onFailure && onFailure();
      notify('error', INVALID_CREDENTIALS_MESSAGE);
      yield put(LoginActions.failure(INVALID_CREDENTIALS_MESSAGE));
      return;
    }
    if (api?.defaults?.headers?.common) {
      api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    }
    onSuccess && onSuccess();
    notify('success', 'Bem vindo');
    yield all([
      put(PaginationParamsCacheActions.reset()),
      put(WarehouseScheduleParamsCacheActions.reset()),
      put(LoginActions.success()),
      put(AuthActions.setData(data)),
    ]);
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(LoginActions.failure(errorMessage));
  }
}
